/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    priority: { description: '', type: 'variant', values: [ 'high' ] }
  },
  rules: [
    {
      if: { priority: 'high' },
      tokens: {
        backgroundColor: '#4b286d',
        iconColor: '#ffffff',
        mobileBackgroundColor: '#4b286d'
      }
    },
    {
      if: { hover: true },
      tokens: {
        backgroundColor: '#7c53a5',
        borderWidth: 0,
        iconColor: '#ffffff',
        mobileBackgroundColor: '#7c53a5'
      }
    },
    {
      if: { focus: true },
      tokens: {
        backgroundColor: 'transparent',
        borderColor: '#4b286d',
        borderWidth: 3,
        iconColor: '#4b286d',
        mobileBackgroundColor: 'transparent'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#3f2a54',
        borderWidth: 0,
        iconColor: '#ffffff',
        mobileBackgroundColor: '#3f2a54'
      }
    },
    {
      if: { inactive: true, priority: 'high' },
      tokens: {
        backgroundColor: '#e3e6e8',
        borderWidth: 0,
        iconColor: '#676e73',
        mobileBackgroundColor: '#e3e6e8'
      }
    },
    {
      if: { inactive: true, priority: null },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        iconColor: 'rgba(0, 0, 0, 0)',
        mobileBackgroundColor: 'rgba(0, 0, 0, 0)'
      }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 32,
    borderWidth: 0,
    iconColor: '#676e73',
    iconSize: 20,
    mobileBackgroundColor: '#f4f4f7',
    opacity: 1,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 8,
    shadow: null
  }
}
export default theme
